export default __webpack_public_path__ + "static/media/KENYA BOT PP.4843f8a0.svg";